<div class="container-fluid p-6">
    <div class="row mb-4">
        <div class="col">
            <h6 class="mb-2">Entwicklung einer mobilen crossplattform App</h6>
            <h2>YOUTINE</h2>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <p>
                Als innovatives Startup hat YOUTINE ein einzigartiges Motivations-Modell entwickelt, das dich nicht nur unterstützt, deine täglichen Routinen zu etablieren, sondern dich aktiv motiviert, dranzubleiben. Mit individuell anpassbaren Routinen, einem cleveren Motivationsbeitrag-System und einer Vielzahl von Funktionen – von Fitnesskursen über Meditationen bis hin zu inspirierenden Affirmationen – wird dein Alltag strukturierter, produktiver und erfüllter.
            </p>
            <p>
                Für das Projekt wurde die aheadware GmbH beauftragt, die komplette technische Umsetzung zu realisieren. Dies umfasste die Entwicklung einer schlanken, performanten Landingpage sowie der eigentlichen App – sowohl als responsive Webanwendung als auch als native iOS- und Android-App. Darüber hinaus gehörte die Implementierung der Backend-Infrastruktur zur effizienten Verwaltung von Nutzerdaten, einer Anbindung der Payment-Systeme und App-Funktionen ebenfalls zum Leistungsumfang.
            </p>
        </div>
    </div>
    <div class="row" style="margin-top: 3rem">
        <div class="col-xl-4">
            <h2>TASK & CHALLENGE</h2>
        </div>
        <div class="col-xl-8">
            <p>
                Die Entwicklung einer App für den B2C-Markt stellt hohe Anforderungen an Technologie, Benutzerfreundlichkeit und Skalierbarkeit. Eine der größten Herausforderungen bestand darin, eine nahtlose User Experience zu schaffen, die sowohl auf Smartphones (iOS und Android) als auch im Browser als responsive Webanwendung überzeugt. Dies erforderte eine konsistente Performance, unabhängig von Gerät, Bildschirmgröße oder Betriebssystem.
            </p>
            <p>
                Darüber hinaus galt es, eine robuste Backend-Infrastruktur zu entwickeln, die nicht nur große Datenmengen effizient verarbeitet, sondern auch den sicheren und schnellen Datenaustausch für tausende gleichzeitige Nutzer gewährleistet. Die App musste intuitiv bedienbar sein, ein ansprechendes Design bieten und gleichzeitig den hohen Erwartungen moderner B2C-Kunden in puncto Performance und Zuverlässigkeit gerecht werden.
            </p>
            <p>
                Die Kombination aus technischer Komplexität, plattformübergreifender Kompatibilität und der Notwendigkeit, ein motivierendes, flüssiges Nutzungserlebnis zu liefern, machte dieses Projekt zu einer spannenden Herausforderung.
            </p>
            <div class="row">
                <div class="col-md-4">
                    <img src="/assets/images/references/ref-youtine-1.png" class="img-fluid" />
                </div>
                <div class="col-md-4">
                    <img src="/assets/images/references/ref-youtine-2.png" class="img-fluid" />
                </div>
                <div class="col-md-4">
                    <img src="/assets/images/references/ref-youtine-3.png" class="img-fluid" />
                </div>
            </div>
        </div>
    </div>
    <div class="row" style="margin-top: 3rem">
        <div class="col-xl-4">
            <h2>SOLUTION</h2>
        </div>
        <div class="col-xl-8">
            <p>
                Die technische Umsetzung von YOUTINE basiert auf einer robusten Architektur, die wir mit Hilfe unserer internen Frameworks und Tools entwickelt haben. Diese Basis ermöglichte eine effiziente und performante Entwicklung, die sowohl eine responsive Webanwendung als auch native Apps für iOS und Android umfasst.
            </p>
            <p>
                Durch den gezielten Einsatz unserer eigenen Technologien konnten wir eine konsistente User Experience über alle Plattformen hinweg sicherstellen und die App für maximale Performance optimieren. Die flexible Architektur erleichtert zudem zukünftige Erweiterungen und Anpassungen, wodurch YOUTINE für weiteres Wachstum im B2C-Markt bestens gerüstet ist.
            </p>
            <div style="margin-top: 2rem">
                <h4>TECHNOLOGIEN</h4>
                <div class="tech-icons">
                    <img class="img-fluid"
                         src="/assets/images/techicons/white/Infront JS@2x-1.png" />
                    <img class="img-fluid"
                         src="/assets/images/techicons/white/JS@2x-1.png" />
                    <img class="img-fluid"
                         src="/assets/images/techicons/white/HTML5 CSS3@2x-1.png" />
                    <img class="img-fluid"
                         src="/assets/images/techicons/white/nodejs@2x-1.png" />
                    <img class="img-fluid"
                         src="/assets/images/techicons/white/SQL@2x-1.png" />
                    <img class="img-fluid"
                         src="/assets/images/techicons/white/Google Cloud@2x-1.png" />
                </div>
            </div>
        </div>
    </div>
    <div class="row" style="margin-top: 6rem">
        <div class="col-12">
            <div class="p-2 p-lg-5" style="border: 1px solid white;">
                <p>
                    “Die Zusammenarbeit mit der aheadware GmbH war von Anfang an äußerst professionell und effizient. Dank ihrer technischen Expertise und der Nutzung interner Frameworks konnten sie YOUTINE nicht nur schnell, sondern auch in höchster Qualität für Web, iOS und Android umsetzen. Besonders beeindruckt hat uns die zuverlässige Unterstützung während des gesamten Entwicklungsprozesses – von der ersten Idee bis zum finalen Launch. aheadware ist für uns ein starker Partner, auf den wir auch in Zukunft setzen werden.“
                </p>
                <p>
                    <i>Jenny Moräntz, Gründerin YOUTINE</i>
                </p>
            </div>
        </div>
    </div>
</div>
